import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Params } from '@angular/router';
import {EMPTY, expand, Observable, reduce} from 'rxjs';
import { IPaginatedResponse } from '../typing/response.interface';
import { environment } from '../shared/environments/environment';
import { IPrice, IPriceCreate, IPriceUpdate } from '../typing/price.interface';

@Injectable({
    providedIn: 'root'
})
export class PriceService {

    constructor(private http: HttpClient) {
    }

    // Получение всех прайсов
    getAllPrices(query: Params = {}): Observable<IPrice[]> {
        return this.getPricesPage(query, 1).pipe(
            expand(response => response.links.next ? this.getPricesPage(query, response.meta.currentPage + 1) : EMPTY),
            reduce((acc: IPrice[], current) => acc.concat(current.data), [])
        );
    }

    // Постраничное получение прайсов
    private getPricesPage(query: Params, page: number): Observable<IPaginatedResponse<IPrice>> {
        const params = { ...query, page, limit: 100 }; // Установите лимит на количество элементов на странице
        return this.http.get<IPaginatedResponse<IPrice>>(`${environment.API_BASE_PATH}/prices`, { params });
    }

    getList(query: Params = {}): Observable<IPaginatedResponse<IPrice>> {
        return this.http.get<IPaginatedResponse<IPrice>>(`${environment.API_BASE_PATH}/prices`, {params: query});
    }

    getPrice(id: number): Observable<IPrice> {
        return this.http.get<IPrice>(`${environment.API_BASE_PATH}/price/${id}`);
    }

    createPrice(price: IPriceCreate): Observable<IPrice> {
        return this.http.post<IPrice>(`${environment.API_BASE_PATH}/price`, price);
    }

    updatePrice(price: IPriceUpdate): Observable<IPrice> {
        return this.http.put<IPrice>(`${environment.API_BASE_PATH}/price/${price.id}`, price);
    }

    deletePrices(data: number[]): Observable<void> {
        return this.http.delete<void>(`${environment.API_BASE_PATH}/prices`, {
            body: data
        });
    }
}
